import { Navigate, useLocation } from "react-router-dom";

const UnProtectedRoute = ({ isAuthenticated, redirectPath = "/dashboard", children}) => {
    const location = useLocation();

    if(isAuthenticated) {
        return <Navigate to={redirectPath} replace state={{ from: location }} />;
    }

    return children
}

export default UnProtectedRoute;